import styled from 'styled-components';
export const SpinnerLayout = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  z-index: 9999;
`;
export const SpinnerContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  color: ${({ theme }) => theme.getColor('white')};
`;
export const SpinnerImage = styled.img `
  width: 50px;
  height: 50px;
  margin-bottom: 16px;
`;
export const SpinnerTitle = styled.p `
  ${({ theme }) => theme.getFontStyle('samsung-700-32')};
  margin-bottom: 8px;
`;
export const SpinnerDescription = styled.p `
  ${({ theme }) => theme.getFontStyle('samsung-700-20')};
`;
//# sourceMappingURL=LoadingSpinner.styles.js.map